const CREATE_COMMUNITY_POST = 'communityPostCreateEdit/CREATE_COMMUNITY_POST';

const EDIT_COMMUNITY_POST = 'communityPostCreateEdit/EDIT_COMMUNITY_POST';

const FETCH_COMMUNITY_POST = 'communityPostCreateEdit/FETCH_COMMUNITY_POST';

export default {
  CREATE_COMMUNITY_POST,
  EDIT_COMMUNITY_POST,
  FETCH_COMMUNITY_POST,
};



// WEBPACK FOOTER //
// ./src/app/redux/front/communityPostCreateEdit/types.js